import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const FilterContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 50px;
  justify-content: space-between;
  overflow-x: hidden;
  padding: 5px 20px;
  padding-right: 10px;
  position: relative;

  background-color: ${({filterColor}) => filterColor && filterColor};
  border-radius: ${({activeRadius, borderRadius}) =>  activeRadius && borderRadius};
  color: ${({backgroundIsDark}) => backgroundIsDark ? "#F6F6F6" : "#000000"};

  ${({
    activeBorder,
    borderColor,
    borderSize,
    borderStyle,
  }) => activeBorder && `
    border-color: ${borderColor ? borderColor : "unset"};
    border-style: ${borderStyle ? borderStyle : ""};
    border-width: ${borderSize ? borderSize : "unset"};
  `}

  #placeholder_selection {
    align-items: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
    width: 100%;
  }

  #selector {
    align-items: center;
    border-left: 1px solid;
    border-left-color: ${({backgroundIsDark}) => backgroundIsDark ? "#F6F6F6" : "#000000"};
    display: flex;
    height: 30px;
    justify-content: center;
    padding-left: 8px;
    width: 20px;
  }
`

export const SelectorContainer = styled.div`
  background-color: #FFF;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  height: 100px;
  padding: 10px;
  width: 100%;
`

export const InputContainer = styled.div`

  align-items: center;
  background-color: #EEEEEE;
  color: #959595;
  display: flex;
  justify-content: center;
  height: 50px;
  width: 50%;

  input {
    background-color: #EEEEEE;
    color: #959595;
    padding: 0 !important;
    margin-left: 10px;
    :first-of-type{
      text-align: right;
      margin-left: 0;
    }
  }
`

export const SliderContainer = styled.div`
  height: 30px;
  width: 100%;
  margin-top: 15px;
  position: relative;

  input[type="range"]{
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    outline: none;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    background-color: transparent;
    pointer-events: none;
}
#slider{
    width: 100%;
    height: 5px;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    border-radius: 5px;
    background: ${({backgroundSliderProperty}) => backgroundSliderProperty && backgroundSliderProperty};
}
input[type="range"]::-webkit-slider-runnable-track{
    -webkit-appearance: none;
    height: 5px;
}
input[type="range"]::-moz-range-track{
    -moz-appearance: none;
    height: 5px;
}
input[type="range"]::-ms-track{
    appearance: none;
    height: 5px;
}
input[type="range"]::-webkit-slider-thumb{
    -webkit-appearance: none;
    height: 1.7em;
    width: 1.7em;
    background-color: ${({sliderColor}) => sliderColor ? sliderColor : "#000000"};
    cursor: pointer;
    margin-top: -9px;
    pointer-events: auto;
    border-radius: 50%;
}
input[type="range"]::-moz-range-thumb{
    -webkit-appearance: none;
    height: 1.7em;
    width: 1.7em;
    cursor: pointer;
    border-radius: 50%;
    background-color: ${({sliderColor}) => sliderColor ? sliderColor : "#000000"};
    pointer-events: auto;
}
input[type="range"]::-ms-thumb{
    appearance: none;
    height: 1.7em;
    width: 1.7em;
    cursor: pointer;
    border-radius: 50%;
    background-color: ${({sliderColor}) => sliderColor ? sliderColor : "#000000"};
    pointer-events: auto;
}
input[type="range"]:active::-webkit-slider-thumb{
    background-color: #ffffff;
    border: 3px solid ${({sliderColor}) => sliderColor ? sliderColor : "#000000"};
}
`